import React from 'react';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
  size?: 'lg' | 'xl';
  className?: string;
  href?: string;
}
const CART_URL = 'https://carlosponte.com/cart/clear?return_to=/cart/add?id=56937498575173&quantity=1';
export function CTAButton({
  children,
  variant = 'primary',
  size = 'lg',
  className = '',
  href
}: CTAButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-bold uppercase tracking-wide rounded-sm cursor-pointer transition-transform duration-150 active:scale-[0.98]';
  const variants = {
    primary: 'bg-[#FF6B00] text-white hover:bg-[#FF8C00] border border-[#FF6B00] hover:border-[#FF8C00]',
    secondary: 'bg-transparent text-[#FF6B00] border-2 border-[#FF6B00] hover:bg-[#FF6B00]/10'
  };
  const sizes = {
    lg: 'px-6 py-3 text-lg',
    xl: 'px-8 py-4 text-xl md:text-2xl'
  };
  const glowEffect = variant === 'primary' ? 'shadow-[0_0_20px_rgba(255,107,0,0.3)] hover:shadow-[0_0_30px_rgba(255,107,0,0.6)]' : '';
  // Fire AddToCart on pointerdown for maximum reliability across all devices
  const fireAddToCart = () => {
    try {
      if (typeof window !== 'undefined' && (window as any).fbq) {
        ;
        (window as any).fbq('track', 'AddToCart');
      }
    } catch {}
  };
  // ALWAYS force the correct cart URL — ignore any href passed in
  const finalHref = CART_URL;
  return <a href={finalHref} onPointerDown={fireAddToCart} onClick={fireAddToCart} className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${glowEffect} ${className}`} data-id="element-83">
      {children}
      <ArrowRight className={`ml-2 ${size === 'xl' ? 'w-6 h-6' : 'w-5 h-5'}`} data-id="element-84" />
    </a>;
}